import globalMessage from "@/utils/globalMessage";
import { useRequest } from 'ahooks';

import { api } from '@/redux/api';

export const useResetPassword = () => {
    const { loading, runAsync: resetPassword } = useRequest(
        (email) => api.forgetpassword(email),
        {
            manual: true,
            onSuccess: () => {
                globalMessage.success({
                    message: 'Success',
                    description: 'Password reset successfully, please check your email',
                    placement: 'topLeft'
                });
            },
            onError: (error) => {
                globalMessage.error({
                    message: 'Error',
                    description: error.message || 'Failed to reset password',
                    placement: 'topLeft'
                });
            }
        }
    );

    const handleResetPassword = (email) => {
        if (!email) {
            return globalMessage.error({
                message: 'Error',
                description: 'Please enter email',
                placement: 'topLeft'
            });
        }
        resetPassword(email);
    };

    return {
        loading,
        resetPassword: handleResetPassword
    };
}; 